var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-footer-social"},[_c('div',{staticClass:"promo-footer-social__wrap"},[_c('div',{staticClass:"promo-footer-social__title"},[_vm._v(_vm._s(_vm.$t("footer.social")))]),_c('SocialIconsList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }